import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

/**
 * A single state waste stream registration with its linked Encamp waste
 * streams. Backs RegistrationDetailDrawer, shared by the staff registrations
 * grid and the customer waste-streams grid.
 */
export const STATE_WASTE_STREAM_REGISTRATION_QUERY = gql(`
  query StateWasteStreamRegistration($id: ID!) {
    stateWasteStreamRegistration(id: $id) {
      id
      tenantId
      tenantName
      facilityId
      facility {
        id
        name
      }
      state
      stateRegisteredId
      profileNumber
      status
      registeredAt
      closedAt
      federalWasteCodes
      formCodes
      sourceCode
      dotId
      dotDescription
      name
      companyDescription
      linkedWasteStreamCount
      linkedWasteStreams {
        id
        name
        federalWasteCodes
        outdated
        missingFederalWasteCodes
        openRegistrationSubmission {
          id
          metadata
        }
      }
    }
  }
`);

export function useStateWasteStreamRegistration(id: string | null) {
  return useQuery(STATE_WASTE_STREAM_REGISTRATION_QUERY, {
    variables: { id: id ?? "" },
    skip: id == null,
    // Submissions are created from the grid without touching this query, so a
    // reopened drawer must not trust its cached linked-stream state.
    fetchPolicy: "cache-and-network",
  });
}

/**
 * Returns every field the drawer's form can edit, not just the few the grid
 * chips read. Apollo normalizes the result onto the cached
 * `StateWasteStreamRegistration` by id, so any edited field this selection
 * omitted would stay stale in the cache and the drawer would drop back out of
 * edit mode showing the pre-save value even though the write succeeded.
 */
export const UPDATE_STATE_WASTE_STREAM_REGISTRATION = gql(`
  mutation UpdateStateWasteStreamRegistration($input: UpdateStateWasteStreamRegistrationInput!) {
    updateStateWasteStreamRegistration(input: $input) {
      id
      state
      stateRegisteredId
      profileNumber
      status
      registeredAt
      closedAt
      federalWasteCodes
      formCodes
      sourceCode
      dotId
      dotDescription
      name
      companyDescription
    }
  }
`);
